import { render, staticRenderFns } from "./HistoryChats.vue?vue&type=template&id=15f8216a"
import script from "./HistoryChats.vue?vue&type=script&lang=js"
export * from "./HistoryChats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports